require("!!C:\\Users\\yds\\Desktop\\situjiate\\situjiate\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\yds\\Desktop\\situjiate\\situjiate\\node_modules\\raw-loader\\index.js!C:\\Users\\yds\\Desktop\\situjiate\\situjiate\\node_modules\\core-js\\modules\\es6.regexp.exec.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es6.regexp.exec.js
// module id = Jbuy
// module chunks = 7